import { Container } from "./Container";
import { SectionHeading } from "./SectionHeading";
import { SkillCard } from "./SkillCard";
import { skillGroups } from "../data/portfolio";

export function SkillsSection() {
  return (
    <section id="skills" className="py-16 md:py-24">
      <Container>
        <SectionHeading
          eyebrow="Capabilities"
          title="Tools are useful. How they are applied matters more."
          description="The skills that make everything happen:"
        />
        <div className="mt-12 grid gap-4 md:grid-cols-2">
          {skillGroups.map((group, index) => (
            <SkillCard key={group.title} {...group} index={index + 1} />
          ))}
        </div>
      </Container>
    </section>
  );
}
